import _createClass from "/var/www/chirpyest_web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/var/www/chirpyest_web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/var/www/chirpyest_web/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/var/www/chirpyest_web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/var/www/chirpyest_web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/var/www/chirpyest_web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/var/www/chirpyest_web/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /*#__PURE__*/function (_Error) {
  _inherits(SentryError, _Error);

  var _super = _createSuper(SentryError);

  /** Display name of this error instance. */
  function SentryError(message) {
    var _this;

    _classCallCheck(this, SentryError);

    _this = _super.call(this, message);
    _this.message = message;
    ;
    _this.name = (this instanceof SentryError ? this.constructor : void 0).prototype.constructor.name;
    Object.setPrototypeOf(_assertThisInitialized(_this), (this instanceof SentryError ? this.constructor : void 0).prototype);
    return _this;
  }

  return _createClass(SentryError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { SentryError };